import { render, staticRenderFns } from "./Lifangti.vue?vue&type=template&id=92ed057a&"
import script from "./Lifangti.vue?vue&type=script&lang=js&"
export * from "./Lifangti.vue?vue&type=script&lang=js&"
import style0 from "./Lifangti.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports